import React, { useEffect, useState } from "react";
import Loading from "../components/Loading";
import "../assets/css/Home.css";

import { useData } from "../contexts/DataContext";

import Sections from "../components/Sections";
import PrimaryDashboard from "../components/PrimaryDashboard";
import { countDashboardsWithChildren } from "../utils/dashboardCount";

import { Box, Grid, Typography, useTheme } from "@mui/material";

import AppBar from "../layouts/AppBar";
import Footer from "../layouts/Footer";

const Home: React.FC = () => {
  const theme = useTheme();

  const { dashboardList, primaryDashboardList, loading, clearSearch } = useData();

  const [sections, setSections] = useState<any>({});
  const [open, setOpen] = React.useState(false);
  const totalDashboardCount = countDashboardsWithChildren(dashboardList);

  useEffect(() => {
    clearSearch();
  }, []);

  useEffect(() => {
    loading ? setOpen(true) : setOpen(false);
  }, [loading]); // Only re-run the effect if loading changes

  useEffect(() => {
    const ss: any = {};
    dashboardList.map((dasahboard) => {
      ss[dasahboard.section] ??= [];
      ss[dasahboard.section].push(dasahboard);
      return true;
    });
    setSections(ss);
  }, [dashboardList]);

  return (
    <Box sx={{ minHeight: "100vh", display: "flex", flexDirection: "column" }}>
      <AppBar />
      <Box sx={{ mx: 2, px: 2 }}>
        <Typography
          sx={{
            fontSize: "18px",
            fontWeight: 300,
            color: theme.palette.text.primary,
          }}
        >
          {`Your list contains a total of ${totalDashboardCount} ${
            totalDashboardCount === 1 ? "dashboard" : "dashboards"
          } organized into ${Object.keys(sections).length} ${
            Object.keys(sections).length === 1 ? "category" : "categories"
          }`}
        </Typography>
      </Box>
      <Grid container spacing={2} padding={0} sx={{ flexGrow: 1 }}>
        {/*
          1. if current role has access to primary dashboard(s)
              -> prioritize Operations Dashboard (id: 58) if available
              -> otherwise show first primary dashboard
          2. else
              -> show Sections home
        */}
        {primaryDashboardList.length > 0 ? (
          (() => {
            const opsDashboard = primaryDashboardList.find(
              (dashboard) => dashboard.id === 58
            );
            const selectedDashboard = opsDashboard ?? primaryDashboardList[0];
            return <PrimaryDashboard dashboardInfo={selectedDashboard} />;
          })()
        ) : (
          <Sections sections={sections} />
        )}
      </Grid>
      <Loading open={loading ?? open} type="spinner" />
      <Footer />
    </Box>
  );
};

export default Home;
